import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { postLoginRedirect } from '@/shared/auth/post-login-redirect'
import { useAuthStore } from '@/shared/auth/stores/authStore'

// Entities is admin/super_admin only. HODs / FOs get
// bounced to their role's home so the URL bar always reflects where
// they're actually allowed.
export const Route = createFileRoute('/entities')({
  beforeLoad: () => {
    const state = useAuthStore.getState()
    if (!state.isAuthenticated) {
      throw redirect({ to: '/login' })
    }
    const role = state.user?.role_name
    if (role !== 'super_admin' && role !== 'admin') {
      throw redirect({ to: postLoginRedirect(role) })
    }
  },
  component: () => <Outlet />,
})
